import "./App.css";
import Login from "./components/Login";
import Home from "./components/Home";
import Dashboard from "./components/Dashboard";
import Register from "./components/Register";
import { AuthProvider } from "./api/authUtils/AuthContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import ContactHome from "./components/ContactHome";
import RuniSort from "./components/RuniSort";
import UploadFile from "./components/UploadFile";
import FractionsHome from "./components/FractionsHome";
import Fractions from "./components/Fractions";
import HiresHome from "./components/HiresHome";
import Hires from "./components/Hires";
import Results from "./components/Results";
import Tokens from "./components/Tokens";
import Settings from "./components/Settings";
import TermsofUseHome from "./components/TermsOfUseHome";
import TermsofUse from "./components/TermsOfUse";
import Contact from "./components/Contact";
import PrivacyPolicyHome from "./components/PrivacyPolicyHome";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RunLocally from "./components/RunLocally";
import References from "./components/References";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
// import RecipientAgreement from "./components/RecipientAgreement";
import FAQ from "./components/FAQ";
import Tutorials from "./components/pages/Tutorials/Tutorials";
import GuestRoute from "./route/GuestRoute";
import ProtectedRoute from "./route/ProtectedRoute";
import Switcher from "./route/Switcher";
import ScrollToTop from "./components/utilities/ScrollToTop";
import Navbar from "./components/Navbar";

import AdminNavbar from "./admin/AdminNavbar";
import AuditTable from "./admin/AuditTable/AuditTable";
import UserTable from "./admin/UserTable/UserTable";
import RunTable from "./admin/RunTable/RunTable";
import JobTable from "./admin/JobTable/JobTable";
import DockerTable from "./admin/DockerTable/DockerTable";
import OrgTable from "./admin/OrgTable/OrgTable";
import TokenTable from "./admin/TokenTable/TokenTable";
import AgreementTable from "./admin/AgreementTable/AgreementTable";
import VerifyEmailNotice from "./components/VerifyEmail";

export default function App() {
  const preloader = document.getElementById("preloader");
  if (preloader) preloader.remove();
  return (
    <Router>
      <AuthProvider>
        <AuthWrapper />
      </AuthProvider>
    </Router>
  );
}
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <>
        <Navbar />
        <Outlet />
      </>
    </ProtectedRoute>
  );
}
function ProtectedAdminLayout() {
  return (
    <ProtectedRoute>
      <>
        <AdminNavbar />
        <Outlet />
      </>
    </ProtectedRoute>
  );
}
function AuthWrapper() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <GuestRoute>
              <Home />
            </GuestRoute>
          }
        />
        <Route
          exact
          path="/login"
          element={
            <GuestRoute>
              <Login />
            </GuestRoute>
          }
        />
        <Route
          exact
          path="/register"
          element={
            <GuestRoute>
              <Register />
            </GuestRoute>
          }
        />
        <Route
          exact
          path="/faq"
          element={
            <GuestRoute>
              <FAQ />
            </GuestRoute>
          }
        />
        <Route
          exact
          path="/forgotpassword"
          element={
            <GuestRoute>
              <ForgotPassword />
            </GuestRoute>
          }
        />
        <Route
          exact
          path="/resetpassword"
          element={
            <GuestRoute>
              <ResetPassword />
            </GuestRoute>
          }
        />
        <Route
          exact
          path="/verify-email"
          element={
            <GuestRoute>
              <VerifyEmailNotice />
            </GuestRoute>
          }
        />
        <Route element={<ProtectedLayout />}>
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/tokens" element={<Tokens />} />
          <Route exact path="/runisort" element={<RuniSort />} />
          <Route exact path="/uploadfile" element={<UploadFile />} />
          <Route exact path="/results" element={<Results />} />
          <Route exact path="/tutorials" element={<Tutorials />} />
          <Route exact path="/runlocally" element={<RunLocally />} />
          <Route exact path="/references" element={<References />} />
          <Route exact path="/settings" element={<Settings />} />
        </Route>
        <Route element={<ProtectedAdminLayout />}>
          <Route exact path="/admin_dashboard" >
            <Route index element={<UserTable />} />
            <Route exact path="audit" element={<AuditTable />} />
            <Route exact path="runs" element={<RunTable />} />
            <Route exact path="jobs" element={<JobTable />} />
            <Route exact path="docker" element={<DockerTable />} />
            <Route exact path="orgs" element={<OrgTable />} />
            <Route exact path="tokens" element={<TokenTable />} />
            <Route exact path="agreements" element={<AgreementTable />} />
            <Route path="*" element={<Navigate to="/admin_dashboard" replace />} />
          </Route>
        </Route>
        <Route
          exact
          path="/contact"
          element={<Switcher before={<ContactHome />} after={<Contact />} />}
        />
        <Route
          exact
          path="/fractions"
          element={
            <Switcher before={<FractionsHome />} after={<Fractions />} />
          }
        />
        <Route
          exact
          path="/hires"
          element={<Switcher before={<HiresHome />} after={<Hires />} />}
        />
        <Route
          exact
          path="/termsofuse"
          element={
            <Switcher before={<TermsofUseHome />} after={<TermsofUse />} />
          }
        />
        <Route
          exact
          path="/privacypolicy"
          element={
            <Switcher
              before={<PrivacyPolicyHome />}
              after={<PrivacyPolicy />}
            />
          }
        />

        {/* <Route path="/tokens?recipient_mail=:email" element={<RecipientAgreement />} /> */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
}
